export default "__VITE_ASSET__B7qNNS7o__"